module.exports = "<igo-context-edit igoContextEditBinding></igo-context-edit>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/context-editor-tool/context-editor-tool.component.html
// module id = 1114
// module chunks = 0